import * as yup from 'yup';

export type Inputs = {
  email: string;
};

export const schema = yup.object().shape({
  email: yup.string().email().required().label('The email')
});
